/** Mirror backend/transfer_logic.py — fee steps up only at each $50 mark ($165 → $15). */

export const DEFAULT_FEE_PERCENT = 10;
export const FEE_INTERVAL = 50;
export const FEE_SCHEDULE_START = 50;
export const FEE_SCHEDULE_END = 100000;
export const FEE_SCHEDULE_STEP = 50;

export function feePercentFromSettings(settings) {
  const val = settings?.service_fee_percent;
  if (val != null && val !== "") return Number(val);
  const legacy = settings?.service_fee_per_100;
  if (legacy != null && legacy !== "") return Number(legacy);
  return DEFAULT_FEE_PERCENT;
}

export function serviceFeeFromTotal(totalAmount, feePercent = DEFAULT_FEE_PERCENT) {
  const total = Math.round((parseFloat(totalAmount) || 0) * 100) / 100;
  if (total <= 0) return 0;
  const pct = Math.max(0, parseFloat(feePercent) || 0);
  const feePerInterval = Math.round(((FEE_INTERVAL * pct) / 100) * 100) / 100;
  let intervals = Math.floor(total / FEE_INTERVAL + 1e-9);
  if (intervals < 1) intervals = 1;
  const fee = Math.round(intervals * feePerInterval * 100) / 100;
  return fee < 0 ? 0 : fee;
}

/** $50 → $100,000 step $50. Same numbers the transfer form uses. */
export function feeScheduleRows(feePercent = DEFAULT_FEE_PERCENT) {
  const rows = [];
  for (let amount = FEE_SCHEDULE_START; amount <= FEE_SCHEDULE_END; amount += FEE_SCHEDULE_STEP) {
    const deducted = splitTotalWithFee(amount, feePercent);
    const onTop = splitNetWithFeeOnTop(amount, feePercent);
    rows.push({
      amount,
      fee: deducted.serviceFee,
      receive: deducted.netAmount,
      totalPaid: onTop.total,
    });
  }
  return rows;
}

export function splitTotalWithFee(totalAmount, feePercent = DEFAULT_FEE_PERCENT) {
  const total = Math.round((parseFloat(totalAmount) || 0) * 100) / 100;
  let fee = serviceFeeFromTotal(total, feePercent);
  let net = Math.round((total - fee) * 100) / 100;
  if (net < 0) {
    net = 0;
    fee = total;
  }
  return { total, serviceFee: fee, netAmount: net };
}

export function splitNetWithFeeOnTop(netAmount, feePercent = DEFAULT_FEE_PERCENT) {
  const net = Math.round((parseFloat(netAmount) || 0) * 100) / 100;
  if (net <= 0) return { total: 0, serviceFee: 0, netAmount: 0 };
  const fee = serviceFeeFromTotal(net, feePercent);
  const total = Math.round((net + fee) * 100) / 100;
  return { total, serviceFee: fee, netAmount: net };
}

/** inputAmount = total (default) or net when senderPaysFee is true */
export function splitWithFeeMode(inputAmount, feePercent = DEFAULT_FEE_PERCENT, senderPaysFee = false) {
  if (senderPaysFee) return splitNetWithFeeOnTop(inputAmount, feePercent);
  return splitTotalWithFee(inputAmount, feePercent);
}
